import { render, staticRenderFns } from "./p_news.vue?vue&type=template&id=5bad3095&scoped=true&"
import script from "./p_news.vue?vue&type=script&lang=js&"
export * from "./p_news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad3095",
  null
  
)

export default component.exports